import React from 'react';
import { Routes, Route } from 'react-router-dom';
import routesConfig, { getTranslation } from '../../../Config/sidebarConfig.js';
import useTranslations from '../../../Hooks/useTranslations';
import translations from '../../../Config/translations.json';

const ContentRouting = () => {
  const t = useTranslations(translations);

  return (
    <div className="content-routing">
      <Routes>
        {routesConfig.map((route, index) => {
          // Get the translated title from the route's titleKey (if available) or labelKey
          const titleKey = route.titleKey || route.labelKey;
          const title = titleKey
            ? getTranslation(t, titleKey, titleKey)
            : '';

          // Clone the element with the title prop injected
          const elementWithTitle = route.element
            ? React.cloneElement(route.element, { title })
            : null;

          return (
            <Route key={index} path={route.path} element={elementWithTitle} />
          );
        })}
      </Routes>
    </div>
  );
};

export default ContentRouting;
